import QuoteBuilderLayout from './QuoteBuilderLayout';
import SelectUnit from './SelectUnit';
import SelectQuantity from './SelectQuantity';
import OptionLengthWithUnit from './OptionLengthWithUnit';
import OptionBoolean from './OptionBoolean';
import OptionIntegerWithRange from './OptionIntegerWithRange';
import OptionSelect from './OptionSelect';
import DrawingMaterialChooser from './DrawingMaterialChooser';
import PrintingColorChooser from './PrintingColorChooser';
import HotStampingChooser from './HotStampingChooser';
import SubmitButton from './SubmitButton';
import styles from './_style.module.scss';
import customerPopupClassNamesFor from 'components/quote_builder_widget/shared/customerPopupClassNames';

export default {
  maxWidth: 800,
  defaultHighlightColor: '#00d4ff',
  QuoteBuilderLayout,
  SelectUnit,
  SelectQuantity,
  OptionLengthWithUnit,
  OptionBoolean,
  OptionIntegerWithRange,
  OptionSelect,
  DrawingMaterialChooser,
  PrintingColorChooser,
  HotStampingChooser,
  SubmitButton,
  // The customer's popup after Submit, in this theme's own label, input and submit button.
  customerPopupClassNames: customerPopupClassNamesFor(styles),
};
